<template>
    <div style="max-width: 60rem;" class="m-auto package-info-wrapper"
            v-bind:class="{ 'is-selected': request.packageId === element.id }">
        <div class="package-indicator-top d-flex flex-fill align-items-center justify-content-center w-100" >
            <img
                style="height: 0.95rem"
                src="/logo/iRender-fulltext-white.svg"
                alt=""
            />
        </div>
        <el-card class="package-el-card"
            v-bind:class="{ 'is-selected': request.packageId === element.id }"
            v-if="element"
            :style="`border: 2px solid ${
                request.packageId === element.id
                    ? '#64B5F6; border-radius: 0px'
                    : 'transparent; border-radius: 0.5rem'
            }`"
            :body-style="{ padding: '25px' }"
        >
            <div class="package-item" style="font-family: Montserrat">
                <div class="ml-3">
                    <div
                        class="
                            d-flex
                            flex-row
                            justify-content-between
                            align-items-center
                        "
                        style="height: 2.5rem"
                    >
                        <div
                            class="d-flex flex-row align-items-center"
                            v-if="element.structuredName"
                        >
                            <div>
                                {{ element.structuredName.split("|")[0] }}
                            </div>
                            <div
                                class="
                                    d-flex
                                    align-items-center
                                    justify-content-center
                                    text-center
                                    ml-2
                                "
                                v-if="
                                    element.structuredName.split('|').length > 1
                                "
                                style="
                                    color: white;
                                    font-size: 0.85rem;
                                    background-color: #42a5f5;
                                    padding: 0 0.75rem;
                                    height: 1.6rem;
                                    border-radius: 0.7rem;
                                "
                            >
                                <span>{{
                                    element.structuredName.split("|")[1]
                                }}</span>
                            </div>
                        </div>
                        <div class="d-flex flex-row align-items-center" v-else>
                            <div>
                                {{ element.name }}
                            </div>
                        </div>

                        <div
                            v-if="type === rentType.FIXED_RENTAL"
                            style="
                                color: white;
                                font-size: 0.8rem;
                                background-color: #66bb6a;
                                padding: 0.2rem 1rem;
                                border-radius: 1rem;
                            "
                        >
                            -
                            {{
                                (
                                    100 -
                                    100 *
                                        (request.totalCost /
                                            request.totalCostByHour)
                                ).toFixed(0)
                            }}%
                        </div>
                    </div>
                    <div
                        v-if="element.id !== '30'"
                        style="height: 2.5rem"
                        class="d-flex flex-row align-items-center"
                    >
                        <div
                            v-if="
                                type !== rentType.FIXED_RENTAL &&
                                (element.id === '1x3090' ||
                                    element.id === '18' ||
                                    element.id === '17' ||
                                    element.id === '16' ||
                                    element.id === '19' ||
                                    element.id === '18' ||
                                    element.id === '20' ||
                                    element.id === '22' ||
                                    element.id === '6x3090')
                            "
                        >
                            <div class="d-flex flex-row align-items-center">
                                <div
                                    class="
                                        d-flex
                                        flex-row
                                        align-items-center
                                        position-relative
                                    "
                                    style="color: #f44336"
                                    v-if="element.priceHourOriginal !== null"
                                >
                                    <div
                                        style="
                                            color: #1976d2;
                                            font-size: 2rem;
                                            line-height: 2rem;
                                        "
                                    >
                                        &nbsp;{{
                                            element.priceOriginalBeforeDecimal
                                        }}
                                    </div>
                                    <div
                                        style="
                                            color: #1976d2;
                                            opacity: 0.85;
                                            font-size: 1.25rem;
                                            line-height: 1.5rem;
                                        "
                                    >
                                        .{{
                                            element.priceOriginalAfterDecimal
                                        }}&nbsp;
                                    </div>
                                    <div
                                        class="position-absolute"
                                        style="
                                            background-color: #f44336;
                                            height: 2px;
                                            width: 100%;
                                            top: 50%;
                                            margin-top: -1px;
                                        "
                                    ></div>
                                </div>
                                <div
                                    class="
                                        d-flex
                                        flex-row
                                        align-items-center
                                        ml-3
                                    "
                                >
                                    <div
                                        :style="`
                      color: ${
                          element.priceHourOriginal !== null
                              ? '#f44336'
                              : '#1976d2'
                      };
                      font-size: 2.25rem;
                      line-height: 2rem;
                    `"
                                    >
                                        {{ element.priceBeforeDecimal }}
                                    </div>
                                    <div
                                        :style="`
                      color: ${
                          element.priceHourOriginal !== null
                              ? '#f44336'
                              : '#1976d2'
                      };
                      opacity: 0.85;
                      font-size: 1.5rem;
                      line-height: 1.5rem;
                    `"
                                    >
                                        .{{ element.priceAfterDecimal }}
                                    </div>
                                </div>
                                <div
                                    v-if="type === rentType.FIXED_RENTAL"
                                    class="ml-3"
                                >
                                    <img
                                        src="/static/image/logo-irender-coin.svg"
                                        width="12"
                                        height="12"
                                    />
                                </div>
                                <div
                                    v-else
                                    class="ml-3"
                                    style="font-size: 0.9rem"
                                >
                                    point
                                </div>
                                <div
                                    class="ml-1"
                                    style="
                                        font-size: 0.9rem;
                                        line-height: 1.7rem;
                                    "
                                >
                                    /
                                    {{
                                        type === rentType.FIXED_RENTAL
                                            ? priceUnit[request.period]
                                            : "hour"
                                    }}
                                </div>
                            </div>
                            <div
                                class="mt-1"
                                v-if="element.priceHourOriginal !== null"
                                style="
                                    font-size: 0.75rem;
                                    color: #42a5f5;
                                    margin-left: 2.5rem;
                                "
                            >
                                from {{ monthNames[new Date().getMonth()] }} 1 -
                                {{ monthNames[new Date().getMonth()] }}
                                {{
                                    new Date(
                                        new Date().getYear(),
                                        new Date().getMonth() + 1,
                                        0
                                    ).getDate()
                                }}
                            </div>
                        </div>
                        <div
                            v-else
                            class="d-flex flex-row align-items-center ml-3"
                        >
                            <div
                                style="
                                    color: #1976d2;
                                    font-size: 2rem;
                                    line-height: 2rem;
                                "
                            >
                                {{ element.priceBeforeDecimal }}
                            </div>
                            <div
                                style="
                                    color: #1976d2;
                                    opacity: 0.85;
                                    font-size: 1.25rem;
                                    line-height: 1.5rem;
                                "
                            >
                                .{{ element.priceAfterDecimal }}
                            </div>
                            <div
                                v-if="type === rentType.FIXED_RENTAL"
                                class="ml-3"
                            >
                                <img
                                    src="/static/image/logo-irender-coin.svg"
                                    width="12"
                                    height="12"
                                />
                            </div>
                            <div v-else class="ml-3" style="font-size: 0.9rem">
                                point
                            </div>
                            <div
                                class="ml-1"
                                style="font-size: 0.9rem; line-height: 1.7rem"
                            >
                                /
                                {{
                                    type === rentType.FIXED_RENTAL
                                        ? priceUnit[request.period]
                                        : "hour"
                                }}
                            </div>
                        </div>
                    </div>
                    <div v-else class="ml-3">
                        <div
                            class="d-flex flex-row align-items-center"
                            v-if="type === rentType.FIXED_RENTAL"
                        >
                            <div
                                class="ml-3"
                                style="
                                    color: #1976d2;
                                    font-size: 2rem;
                                    line-height: 2rem;
                                "
                            >
                                {{ element.priceBeforeDecimal }}
                            </div>
                            <div
                                style="
                                    color: #1976d2;
                                    opacity: 0.85;
                                    font-size: 1.25rem;
                                    line-height: 1.5rem;
                                "
                            >
                                .{{ element.priceAfterDecimal }}
                            </div>
                            <div class="ml-3">
                                <img
                                    src="/static/image/logo-irender-coin.svg"
                                    width="12"
                                    height="12"
                                />
                            </div>
                            <div
                                class="ml-1"
                                style="font-size: 0.9rem; line-height: 1.7rem"
                            >
                                /
                                {{ priceUnit[request.period] }}
                            </div>
                        </div>
                        <div v-else class="d-flex flex-row align-items-center text-nowrap">
                            <div class="ml-3 text-nowrap" style="font-size: 0.9rem">
                                Just from
                            </div>
                            <div
                                class="ml-3"
                                style="
                                    color: #1976d2;
                                    font-size: 2rem;
                                    line-height: 2rem;
                                "
                            >
                                6
                            </div>
                            <div
                                style="
                                    color: #1976d2;
                                    opacity: 0.85;
                                    font-size: 1.25rem;
                                    line-height: 1.5rem;
                                "
                            >
                                .56
                            </div>
                            <div
                                v-if="type === rentType.FIXED_RENTAL"
                                class="ml-3"
                            >
                                <img
                                    src="/static/image/logo-irender-coin.svg"
                                    width="12"
                                    height="12"
                                />
                            </div>
                            <div v-else class="ml-3" style="font-size: 0.9rem">
                                point
                            </div>
                            <div
                                class="ml-1"
                                style="font-size: 0.9rem; line-height: 1.7rem"
                            >
                                / hour
                            </div>
                        </div>
                            <div
                                class="ml-3"
                                style="font-size: 0.7rem; font-style: italic"
                            >
                                (*pay per week)
                            </div>
                    </div>
                </div>
                <div style="font-size: 0.8rem" class="d-flex flex-column">
                    <div class="d-flex flex-row align-items-center mt-2">
                        <div class="dot mr-2">•</div>
                        <div>
                            <span class="title-info">GPU:</span>
                            <span
                                style="
                                    color: #388e3c;
                                    font-size: 1rem;
                                    font-weight: 700;
                                "
                            >
                                <span>{{ element.numberCard }}</span>
                                <span
                                    style="font-size: 0.7rem"
                                    class="ml-1 mr-1"
                                    >x</span
                                >
                                <span>{{ element.detailGraphic }}</span>
                            </span>
                            <span
                                class="ml-2"
                                v-if="
                                    cardInformation.find(
                                        (x) => x.id === element.detailGraphic
                                    )
                                "
                                >{{
                                    cardInformation.find(
                                        (x) => x.id === element.detailGraphic
                                    ).vram
                                }}
                                GB VRAM
                            </span>
                        </div>
                    </div>
                    <div class="d-flex flex-row align-items-center mt-2">
                        <div class="dot">•</div>
                        <el-tooltip :content="element.microarchitecture">
                            <div class="d-flex">
                                <span class="title-info">Microarchitecture :</span>
                                <span><v-clamp autoresize :max-lines="1">{{ element.microarchitecture }}</v-clamp></span>
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="d-flex flex-row align-items-center mt-2">
                        <div class="dot">•</div>
                        <div>
                            <span class="title-info">NVLink :</span>
                            <span
                                v-if="element.nvlink"
                                style="color: forestgreen; font-weight: 600"
                                >{{ element.isNvlinkInstalled ? "Available" : "Request" }}</span
                            >
                            <span v-else>N/A</span>
                        </div>
                    </div>
                    <div class="d-flex flex-row align-items-center mt-2">
                        <div class="dot">•</div>
                        <el-tooltip :content="element.detailCpu">
                            <div class="d-flex">
                                <span class="title-info">CPU:</span>
                                <span><v-clamp autoresize :max-lines="1">{{ element.detailCpu }}</v-clamp></span>
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="d-flex flex-row align-items-center mt-2">
                        <div class="dot">•</div>
                        <div>
                            <span class="title-info">RAM:</span>
                            <span>{{ element.detailMemory }}</span>
                        </div>
                    </div>
                    <div class="d-flex flex-row align-items-center mt-2">
                        <div class="dot">•</div>
                        <div>
                            <span class="title-info">SSD:</span>
                            <span>{{ element.detailStorage }}</span>
                        </div>
                    </div>
                    <div class="d-flex flex-row align-items-center mt-2">
                        <div class="dot">•</div>
                        <div class="d-flex flex-row align-items-center">
                            <div class="title-info">OS:</div>
                            <div
                                v-if="element.enabledWindows"
                                class="d-flex flex-row align-items-center mr-3"
                            >
                                <img style="height: 0.85rem" src="/os/1.svg" />
                                <div class="ml-1">Windows</div>
                            </div>
                            <div
                                v-if="element.enabledUbuntu"
                                class="d-flex flex-row align-items-center"
                            >
                                <img style="height: 0.85rem" src="/os/2.svg" />
                                <div class="ml-1">Ubuntu</div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-row align-items-center mt-2">
                        <div class="dot">•</div>
                        <div>
                            <span class="title-info">Support:</span>
                            <span>{{ element.detailSupport }}</span>
                        </div>
                    </div>
                </div>
                <div
                    class="mt-3 ml-3"
                    style="
                        font-size: 0.85rem;
                        width: 27.5rem;
                        height: 2rem;
                        color: darkorange;
                        font-weight: 600;
                    "
                    v-if="element.id === '28'"
                >
                    For transferring files and installing software purposes.
                    After finishing, please change to other server packages for
                    rendering.
                </div>
                <div v-else class="mt-5" style="height: 2rem">
                    <div
                        class="
                            d-flex
                            flex-row
                            justify-content-start
                            align-items-center
                        "
                        v-if="
                            element.supportSoftware &&
                            element.supportSoftware.split(',').length > 0
                        "
                    >
                        <img
                            :src="`/icon/${softwareItem}.svg`"
                            class="ml-1 mr-1"
                            style="height: 2rem"
                            :key="softwareItem"
                            v-for="softwareItem in element.supportSoftware.split(
                                ','
                            )"
                        />
                        <div
                            class="
                                d-flex
                                flex-row
                                justify-content-center
                                align-items-center
                            "
                            style="width: 3rem"
                        >
                            etc.
                        </div>
                    </div>
                </div>
            </div>
        </el-card>
        <div
            class="package-indicator-bot d-flex flex-fill align-items-center justify-content-center w-100 ">
            <div style=" color: white; font-size: 0.85rem; font-weight: 500; font-family: Montserrat; " >
                SELECTED
            </div>
        </div>
    </div>
</template>
<script>
// Constant
import { RENT_TYPE } from "@/constant/rental";
import { PRICE_UNIT } from "@/constant/fixedRental";

// Extend
import base from "@/scripts/base";

const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

export default {
    extends: base,

    data() {
        return {
            rentType: RENT_TYPE,
            priceUnit: PRICE_UNIT,
            monthNames: monthNames,
        };
    },

    props: {
        element: {
            type: Object,
            default: null,
        },
        request: {
            type: Object,
            default: null,
        },
        type: {
            type: Number,
            default: null,
        },
    },
};
</script>